import { render, staticRenderFns } from "./ProgramModuleActivityList.vue?vue&type=template&id=f15dc6f4&scoped=true"
import script from "./ProgramModuleActivityList.vue?vue&type=script&lang=js"
export * from "./ProgramModuleActivityList.vue?vue&type=script&lang=js"
import style0 from "./ProgramModuleActivityList.vue?vue&type=style&index=0&id=f15dc6f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15dc6f4",
  null
  
)

export default component.exports